import { Language } from 'store/slices/language-slice';

export interface OtpMessages {
  enterDetails: {
    title: string;
    subtitle: string;
    country: string;
    phoneNumber: string;
    next: string;
  };
  seo: {
    title: string;
    description: string;
    keywords: string;
  };
  enableOTPMessages: {
    back: string;
  };
  enterOptView: {
    otpEnabled: string;
    enableOtp: string;
    smsSent: Function;
    enterCode: Function;
    havingTroubleTitle: string;
    havingTroubleBody: (
      linkColor?: string,
      supportEmail?: string | undefined,
    ) => string;
    resend: string;
    goToProfile: string;
    errorMessage: Function;
    otpTimeout: string;
    countdown: Function;
    skipCountdown: Function;
    otpResendErrorMessage: (supportEmail: string | undefined) => string;
  };
}

type Message = {
  [key in Language]: OtpMessages;
};

const messages: Message = {
  en: {
    enterDetails: {
      title: 'Enable OTP',
      subtitle: 'Please enter your mobile number',
      country: 'Country',
      phoneNumber: 'Phone number',
      next: 'Next',
    },
    seo: {
      title: '',
      description: '',
      keywords: '',
    },
    enableOTPMessages: {
      back: '← Back',
    },
    enterOptView: {
      otpEnabled: 'OTP Enabled',
      enableOtp: 'Enable OTP',
      smsSent: (phoneNumber: string) =>
        `We’ve sent an OTP via text message to confirm that ${phoneNumber} is your number`,
      enterCode: (type: string) => `${type} OTP`,
      havingTroubleTitle: 'Need help?',
      havingTroubleBody: (
        linkColor?: string,
        supportEmail?: string | undefined,
      ) =>
        `Send us an email at <a style="color: ${linkColor || 'white'
        }; text-decoration: underline;" href="mailto:${supportEmail}">${supportEmail}</a> or click on the chat button on the bottom right for assistance.`,
      resend: 'Resend OTP',
      countdown: (countDownTime: string) =>
        `Please wait ${countDownTime}s before requesting a new OTP`,
      skipCountdown: (countDownTime: string) =>
        `Resend OTP (${countDownTime}s)`,
      goToProfile: 'Go to profile',
      errorMessage: (otpType: string) =>
        `The ${otpType} OTP that you've entered is incorrect, please try again`,
      otpTimeout: 'Please wait 90 seconds before requesting a new OTP',
      otpResendErrorMessage: (supportEmail: string | undefined) =>
        `You’ve reached your OTP request limit. Contact ${supportEmail} for assistance`,
    },
  },
};

export default messages;
